import { Radio } from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateChoice,
  useFormData,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";

import { StyledRadioBlock, StyledRadioLabel } from "./styles";

interface RadioGroupProps {
  fieldId: string;
}

function RadioGroup({ fieldId }: RadioGroupProps) {
  const findFieldById = useFormData((fd) => fd.findFieldById);
  const { translatorFor, dataTestIdPrefix } = useFormDataContext();

  const field = findFieldById(fieldId);
  const value = field.value.asChoice();
  const items = Array.from(value.items().entries());

  const currentSelection = value.selection()?.code();
  const writable = field.writable;
  const required = field.required;

  const translator = translatorFor(field);

  const handleRadioChange = (newValue: string) => {
    field.setValue(newValue);
  };

  if (!items?.length) {
    return null;
  }

  return (
    <StyledRadioBlock>
      {items?.map(([option]) => {
        const label = translateChoice(translator, field, option, Suffix.LABEL);

        return (
          <StyledRadioLabel key={`${field.id()}_${option.code()}`}>
            <Radio
              name={`${field.id()}-radio-group`}
              value={option.code()}
              checked={currentSelection === option.code()}
              onChange={() => handleRadioChange(option.code())}
              disabled={!writable}
              required={required}
              dataTestId={`${dataTestIdPrefix}-${field.id()}-radio-${option.code()}`}
            />
            {label.toString()}
          </StyledRadioLabel>
        );
      })}
    </StyledRadioBlock>
  );
}

export default RadioGroup;
